<template>
    <div class="container">
        跳转中
    </div>
</template>

<script>
import { isFullURI } from '@/utils/common'
export default {
    name: '',
    data() {
        return {

        }
    },
    created() {
        let { redirect } = this.$route.query
        if (redirect) {
            redirect = decodeURIComponent(redirect)
            if (isFullURI(redirect)) {
                window.location.replace(redirect)
            } else {
                this.$router.replace(redirect)
            }
        } else {
            this.$router.replace('/')
        }
    },
    methods: {

    }
}
</script>

<style lang="less" scoped>
.container {
    text-align: center;
    padding-top: 8rem;
}
</style>
